import { transparencyColors } from '@Components/BigBrowse/GridCardMesh/gridCardConstants';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { observer } from 'mobx-react-lite';

import type { GridCardMeshProps } from '../GridCardMesh2';
import { ProductCardRounded } from '../primitives/ProductCardRounded';

export const BigBrowseProduct = observer(function BigBrowseProduct({
  item,
  onClick,
}: GridCardMeshProps<PlaneTypes.Card_BigBrowse_Product>) {
  return (
    <ProductCardRounded
      position={item.worldPosition}
      size={item.size.width}
      imageUrl={item.data?.imageUrl}
      transparencyColor={transparencyColors[item.type]}
      onClick={onClick}
      uniqueKey={item.key!}
    />
  );
});
